module.exports = __webpack_public_path__ + "img/sportsKoko.8c793e19.webp";